<template>
  <span class="renderer" v-if="object.profile != null">
    <router-link
      :to="'/configurations/profiles/' + object.profile.id"
      class="d-inline-flex align-items-center"
    >
      <ProfileIcon
        :icon="object.profile.icon"
        class="mr-2"
        style="font-size: 0.9em"
      />
      <span class="name">{{ object.profile.name }}</span>
    </router-link>
  </span>
</template>

<script>
import ProfileIcon from "@/components/profiles/ProfileIcon.vue";

export default {
  name: "ProfileRenderer",
  props: ["object"],
  components: { ProfileIcon },
};
</script>

<style lang="scss" scoped></style>
